import PropTypes from 'prop-types';
import React from 'react';

export const pieChartDataProps = PropTypes.arrayOf(
    PropTypes.shape({
        /**
         * make sure the values go in the order of yes, no, maybe
         */
        data: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                value: PropTypes.number,
            })
        ).isRequired,
        /**
         * description for chart
         */
        chartDescription: PropTypes.string,
    })
);

export const minimalPieChartDataProps = PropTypes.arrayOf(
    PropTypes.shape({
        /**
         * make sure the values go in the order of yes, no, maybe
         */
        data: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                value: PropTypes.number,
            })
        ).isRequired,
        /**
         * description for chart
         */
        chartDescription: PropTypes.string,
    })
);
